import classnames from 'classnames';
import { QA_COUNTDOWN } from '@test-config/testIds';
import { Countdown as V3Countdown } from '@stadionhq-v3/football-ui';
import styles from './countdown.module.scss';
import { CountdownProps } from './countdown.types';

const Countdown = ({
  /* props */
  testId = QA_COUNTDOWN.COMPONENT,
  classNames = [],
  nativeProps = {},
  ...props
}: CountdownProps) => {
  const classes = classnames([styles.countdown], classNames);

  return (
    <V3Countdown
      {...nativeProps}
      classNames={[classes]}
      data-testid={testId}
      {...props}
    />
  );
};

export default Countdown;
